/* eslint-disable new-cap */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../images/logo-escuro.png';

export default function CobrancaContrato() {
  function handlePDF() {
    window.html2canvas = html2canvas;
    const doc = new jsPDF('p', 'pt', 'a4');
    const html1 = document.querySelector('#contents');
    const html2 = document.querySelector('#pdf');
    // doc.html(html1, {
    //   callback(doc) {
    //     doc.addPage('a4', 'p');
    //     doc.setPage(2);
    //     console.log(doc.getCurrentPageInfo());
    //     doc.html(html2, {
    //       callback(doc) {
    //         doc.save();
    //       }
    //     });
    //   }
    // });
    doc.html(html1);

    // doc.addPage();
    // doc.html(html2, {
    //   y: 600
    // });

    setTimeout(() => {
      doc.save();
    }, 500);
  }
  return (
    <>
      <button onClick={handlePDF}>save</button>
      <div id="pdf-with-overlay" style={{ position: 'relative', width: '100%' }}>
        <div
          id="contents"
        // style={{
        //   opacity: 0
        // }}
        >
          <div
            id="pdf"
            style={{
              maxWidth: '595px',
              height: '842px',
              wordWrap: 'break-word',
              padding: 10,
              textAlign: 'center'
            }}
          >
            <img src={logo} alt="aa" />
            <h1>akoakoskoaksoaoskoaquiaquiaquiaquiaquiaquiaquiaquiaquiaquiaquiaquiaquiaqui</h1>
            <h1>aqui</h1>
            <h1>aqui</h1>
            <h1>aqui</h1>
            <h1>aqui</h1>
            <h1>aqui</h1>
          </div>

          <div
            id="pdf2"
            style={{
              maxWidth: '595px',
              wordWrap: 'break-word',
              padding: 10,
              textAlign: 'center'
            }}
          >
            <img src={logo} alt="aa" />
            <h1>div 2</h1>
          </div>
        </div>
        <div
          id="pdf-overlay"
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10,
            backgroundColor: '#F6F7FF'
          }}
        />
      </div>

    </>
  );
}
